<div id="table">
    <app-mat-data-grid 
        class="page-data-grid"
        [formValid]="true"
        [header]="header"
        [(dataSource)]="data" 
        [displayedColumns]="[ 'Name', 'QuickConnectType', 'QueueName', 'ContactFlowName', 'Username', 'PhoneNumber']"   
        [columnNames]="[ 'Name', 'QuickConnect Type', 'Queue Name', 'ContactFlow Name', 'Username', 'Phone Number']"
        [pageSizeOptions] = "[5, 15, 25, 50]"
        [buttonConfig]="{
            edit: {show: false},
            delete: {show:false},
            create: {show: false}
        }">
    </app-mat-data-grid>
    <ng-template let-element #active>
        <mat-slide-toggle [(ngModel)]="element.active">Active</mat-slide-toggle>
    </ng-template>
    <ng-template let-element #serviceNowTicket>
        <input type="text" [(ngModel)]="element.serviceNow" placeholder="Service Now">
    </ng-template>
    <ng-template #header>
        <button mat-raised-button color="primary" (click)="buildCSV();">Download CSV</button>
    </ng-template>
</div>

<a id="downloadLink" hidden></a>